import React from 'react';
import { useData } from '../../hooks';
import { useRTL } from 'ca-hooks';
import { Heading } from '@kaizen/typography';
import styles from './WelcomeSreenSurveyName.scss';

export interface WelcomeSreenSurveyNameProps {
  value: string;
}

export const WelcomeSreenSurveyName = () => {
  const { survey_name, welcome_screen_locale } = useData();
  const isRTL = useRTL(welcome_screen_locale.code);
  return (
    <div
      className={styles.WelcomeSreenSurveyNameContainer}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <Heading
        variant="display-0"
        tag="h1"
        classNameOverride={styles.WelcomeScreenHeadingText}
      >
        {survey_name}
      </Heading>
    </div>
  );
};
